const inDevelopment = () => import.meta.env.DEV;

const inProduction = () => !inDevelopment() && window.location.hostname === 'app.clientzen.io';

const inStaging = () => !inDevelopment() && window.location.hostname === 'app-staging.clientzen.io';

export { inDevelopment, inProduction, inStaging };
